/* import __COLOCATED_TEMPLATE__ from './invalid-plan-combination-modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();